export default __webpack_public_path__ + "static/media/Timeline.5bfff9be.webp";